import { css } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const header = css({
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  padding: Spacing.XS,
  maxWidth: 200,
})

export const highlightedEmoji = css({
  fontFamily: 'serif',
  fontSize: '24px',
  lineHeight: '28px',
})
